import {PriceAndBrandSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {TrackingPromotionCreative} from '@aboutyou/legacy-tracking-sdk';
import {TrackPromotions, useTrackOriginClick} from '@aboutyou/tracking';
import {
  BrandLogo,
  FONT_SIZES,
  FONT_WEIGHTS,
  Text,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {SelectedSize} from '../../../features/SizeSelection/hooks/useSelectedSizeState';
import {SoldOutState} from '../PriceAndBrandHorizontal/SoldOutState';
import {useBrandLocationWithState} from '../utils';

export interface BrandAndProductNameQuickViewProps {
  selectedSize: SelectedSize;
  className?: string;
}

export const BrandAndProductNameQuickViewView: React.FC<
  BrandAndProductNameQuickViewProps & PriceAndBrandSection
> = ({product, brandLogo, className}) => {
  const trackOriginClick = useTrackOriginClick();

  const brandPathWithState = useBrandLocationWithState({
    path: brandLogo.brand.path,
    brandPreview: brandLogo.brandPreview,
  });

  if (product.isSoldOut) {
    return (
      <SoldOutState
        productImage={product.primaryBustImage}
        productName={product.name}
        brandName={brandLogo.brand.name}
        shareUrl={product.shareUrl}
      />
    );
  }

  return (
    <Section className={className} data-testid="PriceAndBrandQuickView">
      <BrandAndProductNameWrapper>
        <BrandAndProductnameWrapper>
          <TrackPromotions
            promotion={{
              source: TrackingPromotionCreative.BrandReco,
              brand: {
                id: brandLogo.brand.id,
                name: brandLogo.brand.name,
                path: brandLogo.brand.path,
              },
            }}
            streamPosition={NaN}
          >
            <StyledBrandname
              name={brandLogo.brand.name}
              path={brandPathWithState}
              onClick={trackOriginClick('brands_logo')}
              maxHeight="18px"
              alignment="left"
            />
          </TrackPromotions>
          <ProductName>{product.name}</ProductName>
        </BrandAndProductnameWrapper>
      </BrandAndProductNameWrapper>
    </Section>
  );
};

const StyledBrandname = styled(BrandLogo)`
  span {
    text-transform: uppercase;
    font-size: 0.75rem;
  }
`;

export const Section = styled.section`
  display: flex;
  &&& {
    padding: 0;
    margin: 0;
  }
`;

export const BrandAndProductNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
`;

const ProductName = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.mediumBold};
  line-height: ${FONT_SIZES.px18};
`;

const BrandAndProductnameWrapper = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  padding: 8px 16px;
  white-space: nowrap;
`;
